module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "user-details-container"
  }, [_c('h1', [_vm._v("User Details")]), _vm._v(" "), _c('div', {
    staticClass: "full-name"
  }, [_c('div', [_vm._v(_vm._s(_vm.fullName))])]), _vm._v(" "), _c('div', {
    staticClass: "user-data-container"
  }, [_c('div', {
    staticClass: "avatar"
  }, [_c('img', {
    attrs: {
      "src": _vm.avatar,
      "width": "200",
      "height": "200"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "user-data-1"
  }, [_c('div', [_vm._v(" FIRST NAME - " + _vm._s(_vm.profile.first_name))]), _vm._v(" "), _c('div', [_vm._v(" LAST NAME - " + _vm._s(_vm.profile.last_name))]), _vm._v(" "), _c('div', [_vm._v(" EMAIL - " + _vm._s(_vm.profile.email))]), _vm._v(" "), _c('div', [_vm._v(" BIRTHDATE - " + _vm._s(_vm.profile.birthdate))])]), _vm._v(" "), _c('div', {
    staticClass: "user-data-2"
  }, [_c('div', [_vm._v(" CITY - " + _vm._s(_vm.profile.place))]), _vm._v(" "), _c('div', [_vm._v(" DATE CREATED - " + _vm._s(_vm.profile.date_joined))]), _vm._v(" "), _c('div', [_vm._v(" USER GROUPS - " + _vm._s(_vm.profile.user_groups))])])]), _vm._v(" "), _c('div', {
    staticClass: "user-records-title"
  }, [_c('h1', [_vm._v("Recorded videos (" + _vm._s(_vm.profile.valid_records_amt) + " (" + _vm._s(_vm.profile.all_records_amt) + ")) - Missions (" + _vm._s(_vm.profile.events_amt) + ")")])]), _vm._v(" "), _c('div', {
    staticClass: "user-records"
  }, [_c('user-records', {
    attrs: {
      "userId": _vm.userId
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6ec697e9"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/user/UserDetails.vue
// module id = 1056
// module chunks = 1